/** @jsxImportSource @emotion/react */
import React, { useCallback, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { NewsDto } from "../../..";
import NotesAccordion from "../../../../../../../components/NotesAccordion/NotesAccordion";
import TextLink from "../../../../../../../components/TextLink/TextLink";
import { TEXT_LINK_SIZES } from "../../../../../../../components/TextLink/types";
import RectangleLoader from "../../../../../../../shared/components/loaders/RectangleLoader";
import { NEWS_DIALOG_SIZES } from "../../../types/enums";

import ReleaseNotesDetails from "./ReleaseNotesDetails";
import ReleaseNotesTitle from "./ReleaseNotesTitle";

interface ReleaseNotesDialogContentProps {
  isLoading: boolean;
  newsData: NewsDto | null;
}

const ReleaseNotesDialogContent = ({
  isLoading,
  newsData
}: ReleaseNotesDialogContentProps) => {
  const { t } = useTranslation();

  const [expanded, setExpanded] = useState<string>("panel0");
  const [showOlder, setShowOlder] = useState<boolean>(false);

  const moreThanOneNote =
    Array.isArray(newsData?.history) && newsData?.history.length !== 0;

  const allReleaseNotes = useCallback(() => {
    if (!newsData) return [];

    const latestReleaseNote: NewsDto = {
      ...newsData,
      history: null
    };

    const historyNotes = Array.isArray(newsData.history)
      ? newsData.history
      : [];

    return [latestReleaseNote, ...historyNotes];
  }, [newsData]);

  const handleCollapse = (panel: string, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : "");
  };

  const handleToggleShowOlder = () => {
    setShowOlder(prev => !prev);
  };

  return (
    <div
      css={css({
        minHeight: NEWS_DIALOG_SIZES.releaseNewsDialogMinHeight
      })}
    >
      {isLoading && (
        <RectangleLoader
          testId="release-notes-loader"
          width="100%"
          height={NEWS_DIALOG_SIZES.dialogImageHeight}
        />
      )}
      {!isLoading &&
        allReleaseNotes()?.map((note: NewsDto, index: number) => (
          <NotesAccordion
            rootPadding="16px 16px 10px 16px"
            detailsPadding="0 16px"
            key={note.id}
            index={index}
            expandedPanel={expanded}
            isLast={index === allReleaseNotes().length - 1}
            onCollapse={handleCollapse}
            title={<ReleaseNotesTitle note={note} index={index} />}
            details={<ReleaseNotesDetails note={note} />}
            showAll={showOlder}
          />
        ))}
      {!showOlder && !isLoading && moreThanOneNote && (
        <TextLink
          size={TEXT_LINK_SIZES.Small}
          onClick={handleToggleShowOlder}
          sx={{ overflowWrap: "break-word" }}
          customStyle={{ paddingTop: "16px" }}
        >
          {!showOlder && t("Details##show older")}
        </TextLink>
      )}
    </div>
  );
};

export default React.memo(ReleaseNotesDialogContent);
